import React from 'react'

import classNames from './Toggle.css'

export default function Toggle ({ value }) {
  return (
    <div className={value ? classNames.wrapChecked : classNames.wrap}>
      <div className={value ? classNames.dotChecked : classNames.dot} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Toggle.js